import { URL_REPLACEMENT } from '$const';
import { get } from '~services/api/methods';

export async function fetchJobList(status: string) {
  const requestUrl = `${URL_REPLACEMENT.SYMFONY_URL}/o2e/api/job/list/${status}`;
  const response = await get(requestUrl);
  return response;
}

export async function isOpen(jobId: number, clientId: number) {
  const requestUrl = `${URL_REPLACEMENT.SYMFONY_URL}/o2e/api/job/is_open/${jobId}/${clientId}`;
  const response = await get(requestUrl);
  return response;
}
